<sc-flex vertical fitHeight stretchContent>
    <sc-dialog-title>
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.station-selection-dialog.title"></sc-dictionary-label>
    </sc-dialog-title>
    <sc-flex-fitting-content vertical>
        <app-structure-selection [request]="request" (selectionChanged)="handleSelectionChange($event)"></app-structure-selection>
    </sc-flex-fitting-content>
    <sc-actionbar>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-cancel-button (click)="cancelDialog()" dictionaryKey="shared.selection-dialog.action.cancel"></sc-cancel-button>
        <sc-content-spacer></sc-content-spacer>
        <sc-confirm-button primary (click)="confirmDialog()" [disabled]="selection == null || !selection.valid" dictionaryKey="shared.selection-dialog.action.confirm"></sc-confirm-button>
    </sc-actionbar>
</sc-flex>
